import React, {useEffect, useState} from "react";
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";
import {addBasketBundle} from "../../../../../../api/ECOM/addBasketBundle.api";
import {refreshCart} from "../../../../../../actions/cart";
import {useDispatch} from "react-redux";

export interface BundleId {
    BundleId: string;
}
export const BundleSummaryAddToCart: React.FC<BundleId> = ({BundleId}) => {
    const translate = useI18N();
    const dispatch = useDispatch();
    const [quantity, setQuantity] = React.useState(1);
    const minQuantity = 1;
    const maxQuantity = 9999;
    const [addingToCart, setAddingToCart] = useState(false);
    const [addingToCartSuccess, setAddingToCartSuccess] = useState(false);
    const [addingToCartError, setAddingToCartError] = useState(false);

    const handleIncrement = () => {
        if (quantity < maxQuantity) {
            setQuantity(quantity + 1);
        }
    };

    const handleDecrement = () => {
        if (quantity > minQuantity) {
            setQuantity(quantity - 1);
        }
    };

    const handleChange = (e) => {
        setQuantity(e.target.value);
    };

    const handleBlur = () => {
        const minimum = minQuantity > 0 ? minQuantity : 1;
        setQuantity((prev) => Math.max(minimum, Math.min(maxQuantity, Math.round(Number(prev)))));
    };

    const handleAddToCart = async () => {
        setAddingToCart(true);
        try {
            await addBasketBundle(BundleId, quantity);
            setAddingToCartSuccess(true);
            setTimeout(() => {
                setAddingToCartSuccess(false);
                setQuantity(1);
            }, 2000);
        } catch (error) {
            console.error("Error adding to cart:", error);
            setAddingToCartError(true);
        } finally {
            setAddingToCart(false);
        }
    };

    const buttonLabel = () => {
        switch (true) {
            case addingToCartSuccess:
                return translate('Added to cart');
            case addingToCartError:
                return translate('Failed to add to cart');
            case addingToCart:
                return translate('Adding to cart');
            default:
                return translate('Add to cart');
        }
    }

    useEffect(() => {
        if (addingToCartSuccess) {
            dispatch(refreshCart());
        }

    }, [addingToCartSuccess]);

    return (
        <div className={"pdp-bundle__add-to-cart"}>
            <div className="add-to-cart__controls">
                <button className={"add-to-cart__controls--decrement"}
                        aria-label={translate("Decrement quantity")} onClick={handleDecrement}
                        disabled={minQuantity > 0 ? quantity <= minQuantity : quantity <= 1}></button>
                <input type="number" value={quantity} aria-label={translate("Quantity input")} onChange={handleChange}
                       onBlur={handleBlur} min={minQuantity}
                       max={maxQuantity}/>
                <button className={"add-to-cart__controls--increment"} onClick={handleIncrement}
                        aria-label={translate("Increment quantity")}
                        disabled={quantity >= maxQuantity}></button>
            </div>
            <button
                className={`btn btn-primary ${addingToCartSuccess ? "add-to-cart__button add-to-cart__button--added" : "add-to-cart__button"}`}
                onClick={handleAddToCart}
                disabled={addingToCartError || addingToCart || addingToCartSuccess}
            >
                {buttonLabel()}
            </button>
        </div>
    )
}
